import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CreateStoreComponent} from "@app/features/store-invitation/create-store/create-store.component";
import { ProviderLoginSetupComponent } from '@app/features/store-invitation/provider-login-setup/provider-login-setup.component';

const routes: Routes = [
  {
    path: 'create-store/:id',
    component: CreateStoreComponent
  }, {
    path: 'setup-provider-login/:id',
    component: ProviderLoginSetupComponent
  }, {
    path: 'create-store',
    component: CreateStoreComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreInvitationRoutingModule {
}
